import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import useActions from './useActions';
import { fetchSerieResult } from 'actions';

const useCurrentSerieResult = id => {
  const dispatchFetchSerieResult = useActions(fetchSerieResult);

  const result = useSelector(
    ({ serie }) => serie.result,
  );

  const memoizedFetch = useCallback(() => {
    if (id)
    dispatchFetchSerieResult(id, {onSuccess: () => console.log("yooo")})
  }, [dispatchFetchSerieResult, id]);

  useEffect(() => {
    memoizedFetch();
  }, [memoizedFetch]);

  return result;
};

export default useCurrentSerieResult;
